import { atomWithReset } from 'jotai/utils'
import { type CMSProductShelfData } from '@/features/cms/components/CMS/types'

type ComplementaryShelfDisplayData = {
  shelfData: CMSProductShelfData
  productIndex: number
  productName: string
}

type ComplementaryShelfState = {
  isEligibleForShelf: boolean
  shelfDisplayData: ComplementaryShelfDisplayData | null
  hasDismissed: boolean
}

export const defaultComplementaryShelfState: ComplementaryShelfState = {
  isEligibleForShelf: true,
  shelfDisplayData: null,
  hasDismissed: false,
}

export const complementaryShelfStateAtom = atomWithReset<ComplementaryShelfState>(
  defaultComplementaryShelfState,
)
complementaryShelfStateAtom.debugLabel = 'complementaryShelfStateAtom'
